/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Modal,
  Row,
  Select,
} from 'antd';
import styles from './styles.module.scss';
// import './index.scss'
import styled from 'styled-components';
import { SelectStringInput } from '../../../general/select-input';
import { Content } from 'antd/es/layout/layout';

import { SkillTypeList, SkillCategoryList } from '../../../../utils/object';
import axiosInstance from '../../../../axios_instance';
import { errorHandling } from '../../../../utils/helper';
import errorColumnMap from '../../../../utils/error-message-mapping';
import ModalCloseIcon from '../../../general/icon';

const formRules: object[] = [
  {
    required: true,
    message: 'Please input skill name!',
  },
  ({ getFieldValue }: any) => ({
    validator(_: any, value: any) {
      if (!value || value.length < 50) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error('Ensure the value has at most 50 characters.')
      );
    },
  }),
];
const StyledModal = styled(Modal)`
  background-color: #303843;
  font-size: 32px;
  color: white;
  padding: 0px;
  border-radius: 4px;
  .ant-modal-close {
    position: absolute;
    top: 40px;
    right: 60px;
  }
  div{
    color:white
  }
  .ant-modal-content {
    background-color: #303843;
    padding: 30px;
    height: 400px;
  .ant-modal-title {
    color: white;
    margin-left: 20px;
    font-size: 30px;
  }
  .ant-modal-header {
    background-color: #303843;
  }
  .ant-upload-wrapper {
    margin: 20px;
  }
  .anticon {
    color: white;
  }
  .ant-btn-primary {
    height: 40px;
    width: 80px;

    background: #8cc63e;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    right:30px;
    margin-bottom: 20px;

    /* White */

    color: #ffffff;
  }
  .ant-btn-primary:disabled {
    height: 40px;
    width: 70px;

    background: #79808a;
    border-radius: 4px;
    margin-right: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 0px;
    margin-bottom: 20px;
    /* White */

    color: #9e9e9e;
  }
  .ant-btn-default {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    text-align: center;

    /* White */

    color: #ffffff;

    height: 40px;
    width: 80px;
    box-shadow: -2px 10px 30px rgba(0, 0, 0, 0.25);
    background: #303843;
    border-radius: 4px;
    position: absolute;
    bottom: 0px;
    right: 140px;
    margin-bottom: 20px;
  }
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    height: 43px !important;
    background-color: #59606a !important;
    color: #d5d5d5 !important;
    padding-top: 6px !important;
    border: none !important;
  }
  .ant-select-selection-item-remove {
    line-height: 17px;
  }
  .ant-select-item-option-selected {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    background-color: #303843 !important;
  }
  .ant-select-selection-placeholder {
    color: #d5d5d5 !important;
  }
  border: none;
  border-bottom: #59606a !important;
`;
const StyledInput = styled(Input)`
  background-color: #59606a !important;
  border: #59606a;
  height: 43px;

  color: #d5d5d5 !important;
  ::-webkit-calendar-picker-indicator {
    content: url(/calendar_today.png);
    background: #59606a;
  }
`;
const { Option } = Select;
interface SkillAddModalProps {
  isModalOpen: boolean;
  setIsModalOpen: any;
}
const SkillAddModal: React.FC<SkillAddModalProps> = ({
  isModalOpen,
  setIsModalOpen,
}: SkillAddModalProps) => {
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [form] = Form.useForm();
  const [categories, setCategories] = useState<Array<{ [key: string]: number }>>([]);

  useEffect(() => {
    if (isModalOpen) {
      axiosInstance
        .get('/api/v1/skills/categories')
        .then((response) => {
          const formatted = response.data.map((cat: any) => ({
            [cat.name]: cat.id,
          }));
          setCategories(formatted);
        })
        .catch((error) => {
          console.error('Failed to fetch categories', error);
        });
    }
  }, [isModalOpen]);

  const addSkill = (values: any) => {
    axiosInstance
      .post('/api/v1/skills', values)
      .then((response) => {
        message.success(`Skill created successfully`);
        setIsModalOpen(false);
        window.location.reload();
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      });
  };
  return (
    <>
      <StyledModal
        okText="Create"
        cancelText="Cancel"
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              addSkill(values);
              form.resetFields();
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
        maskClosable={false}
        centered
        destroyOnClose={true}
        title={
          <>
            Add Skill
            <p className={styles['sub-title']}>Add a new skill here</p>
          </>
        }
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        width="50%"
        // okButtonProps={{
        //   disabled:
        //     !skill ||
        //     !planType ||
        //     !planData['start_date'] ||
        //     !planData['end_date'],
        // }}
        closeIcon={
          <>
            <ModalCloseIcon />
          </>
        }
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          initialValues={{ modifier: 'public' }}
        >
          <Row className={styles['row']}>
            <Col span={24} className={styles['col']}>
              <p className={styles['label']}>Skill Name</p>
              <Form.Item name="skill_name" rules={formRules}>
                <StyledInput
                  type="textarea"
                  style={{
                    borderBottom:
                      'skill_name' in errorMessage ? '1px solid red' : '',
                  }}
                />
              </Form.Item>
              <p style={{ color: 'red' }}>
                {'skill_name' in errorMessage ? errorMessage['skill_name'] : ''}
              </p>
            </Col>
          </Row>
          <Row className={styles['row']}>
            <Col span={12} style={{ paddingRight: '10px' }}>
              <p className={styles['label']}>Skill Type</p>
              <Form.Item
                name="skill_type"
                rules={[
                  { required: true, message: 'Please select skill type!' },
                ]}
              >
                <StyledSelect
                  placeholder="Select"
                  dropdownStyle={{
                    background: '#59606a',
                    color: 'white',
                  }}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                >
                  {SkillTypeList.map(
                    (type: { [index: string]: number | undefined }) => {
                      return Object.entries(type).map(([key, value]) => (
                        <Option key={key} value={value}>
                          {key}
                        </Option>
                      ));
                    }
                  )}
                </StyledSelect>
              </Form.Item>
              <p style={{ color: 'red' }}>
                {'skill_name' in errorMessage ? errorMessage['skill_name'] : ''}
              </p>
            </Col>
            <Col span={12} style={{ paddingLeft: '10px' }}>
              <p className={styles['label']}>Skill Category</p>
              <Form.Item
                name="skill_categories"
                rules={[
                  { required: true, message: 'Please select skill category!' },
                ]}
              >
                <StyledSelect
                  placeholder="Select"
                  mode="multiple"
                  showSearch={false}
                  maxTagCount={1}
                  dropdownStyle={{
                    background: '#59606a',
                    height: 'auto',
                  }}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                >
                  {categories.map(
                    (type: { [index: string]: number | undefined }) => {
                      return Object.entries(type).map(([key, value]) => (
                        <Option key={key} value={value}>
                          {key}
                        </Option>
                      ));
                    }
                  )}
                </StyledSelect>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </StyledModal>
    </>
  );
};

export default SkillAddModal;
